import { render, staticRenderFns } from "./GridSetup.vue?vue&type=template&id=07ead114&"
import script from "./GridSetup.vue?vue&type=script&lang=js&"
export * from "./GridSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports